<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @input="onDialogInput"
    >
      <v-card>
        <v-toolbar dark color="#4cd4ca">
          <v-btn
            icon
            dark
            @click="
              dialog = false;
              handleClose();
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false"> Share </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div class="image-container">
          <img
            class="main-image"
            :src="removeQueryParameter(vehicle.adImage)"
          />
          <img
            class="additional-image"
            src="../assets/GT Collective-logos_transparent.png"
          />
        </div>
        <v-card-title class="text-h4 d-flex justify-space-between align-center"
          >{{ vehicle.title }}
          <v-btn icon @click.stop="addOrRemoveFromWishlist(vehicle)">
            <v-icon :color="isInWishlist ? 'red' : 'grey'"> mdi-heart </v-icon>
          </v-btn>
        </v-card-title>
        <v-list three-line subheader>
          <v-subheader>Ad Details</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <span class="text--secondary" style="white-space: pre-line">{{
                truncateAndReplaceText(vehicle.description)
              }}</span>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <!-- Show price or 'SOLD' image based on conditions -->
              <template v-if="vehicle.price !== 'SOLD'">
                <v-card-text>
                  <p class="text-h4" style="color: #4cd4ca">
                    ${{ vehicle.price }}*
                  </p>
                  <p class="text-medium-emphasis text-caption">
                    *Estimated Landed Price in AUD
                  </p>
                </v-card-text>
                <v-list-item-subtitle class="text-medium-emphasis text-caption"
                  >Free Shipping where applicable, Price includes, Government
                  Duty, GST, Local Port Charges</v-list-item-subtitle
                >
              </template>
              <template v-else>
                <v-card-text
                  v-if="$vuetify.breakpoint.smAndDown"
                  class="text-center"
                >
                  <p class="text-h4" style="color: #4cd4ca">
                    <v-img
                      src="../assets/sold.png"
                      width="120"
                      class="mx-auto"
                    ></v-img>
                  </p>
                </v-card-text>
                <v-card-text
                  v-if="$vuetify.breakpoint.mdAndUp"
                  class="text-center"
                >
                  <p class="text-h4" style="color: #4cd4ca">
                    <v-img src="../assets/sold.png" width="120"></v-img>
                  </p>
                </v-card-text>
              </template>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Location</v-list-item-title>
              <v-list-item-subtitle>{{ vehicle.address }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    vehicle: Object,
    selectedVehicle: Number,
    handleClose: Function,
    isInWishlist: Boolean,
    addOrRemoveFromWishlist: Function,
  },
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    selectedVehicle(newValue) {
      if (newValue === this.vehicle.id) {
        this.dialog = true;
      }
    },
  },
  methods: {
    onDialogInput(value) {
      // Emit event when dialog is closed
      if (!value) {
        this.$emit("dialog-closed");
      }
    },
    removeQueryParameter(url) {
      // Function to remove the query parameter from the URL
      return url.replace(/\?x-oss-process=style\/[^&]*/g, "");
    },
    removeNonEnglishCharacters(title) {
      // Remove non-English characters using a regular expression
      return title.replace(/[^A-Za-z0-9\s]/g, "");
    },
    truncateAndReplaceText(description) {
      // Perform "find and replace"
      const replacedText = description.replace(/51GT3/g, "GT-Collective");

      return replacedText;
    },
  },
};
</script>

<style scoped>
* /deep/ .v-list-item__subtitle {
  white-space: pre-line;
}
.image-container {
  position: relative;
}

.main-image {
  height: 50rem;
  width: 100%;
  object-fit: cover;
  /* Add any other styles you need for the main image here */
}

.additional-image {
  position: absolute;
  bottom: 10px; /* Adjust this value to position the image as needed */
  right: 10px; /* Adjust this value to position the image as needed */
  width: 200px; /* Adjust the width of the additional image */
  height: auto;
  /* Add any other styles you need for the additional image here */
}
</style>
